var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSync = function SvgSync(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sync"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 12.3571V16.3571H1",
    stroke: "#9E9FA4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17 8.35706V4.35706H21",
    stroke: "#9E9FA4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.2508 4.35437C18.63 5.79132 19.4724 7.65943 19.6361 9.64448C19.7999 11.6295 19.275 13.6104 18.1498 15.254C17.0246 16.8975 15.3678 18.1034 13.458 18.6689C11.5481 19.2343 9.50181 19.1248 7.66321 18.3588",
    stroke: "#9E9FA4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.74852 16.3597C3.37224 14.9221 2.53253 13.0546 2.37041 11.071C2.20828 9.08734 2.73361 7.10832 3.85818 5.46624C4.98275 3.82416 6.63808 2.61902 8.5462 2.05319C10.4543 1.48735 12.499 1.59528 14.337 2.35885",
    stroke: "#9E9FA4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgSync;